import { FunctionComponent, useEffect, useState } from 'react';
import classnames from 'classnames';

import ProductInfo, { SectionTypes } from 'models/ProductInfo';

import HtmlStyledContent from 'components/layout/HtmlStyledContent';
import { Variants } from 'components/layout/HtmlStyledContent/types';
import LayoutContainer from 'components/layout/LayoutContainer';

import StyledComponent from './styles';
import { Props } from './types';

const PublicLayoutSectionProductInfo: FunctionComponent<Props> = ({ infos, headline, subheadlines }) => {
    const [sections, setSections] = useState<Record<string, ProductInfo[]>>(null);
    const [openSection, setOpenSection] = useState<string>(subheadlines.benefits);

    useEffect(() => {
        const indications: ProductInfo[] = [];
        const contraindications: ProductInfo[] = [];
        const benefits: ProductInfo[] = [];

        infos.forEach(item => {
            if (item.section === SectionTypes.Indications) {
                indications.push(item);
                return;
            }
            if (item.section === SectionTypes.Contraindications) {
                contraindications.push(item);
                return;
            }
            benefits.push(item);
        });
        setSections({ indications, contraindications, benefits });
    }, [infos]);

    const renderSection = (section: ProductInfo[], sectionTitle: string, iconUrl: string) => {
        if (!section.length) return null;

        return (
            <div
                className={classnames('section-container', {
                    'is-open': Boolean(openSection === sectionTitle),
                })}
                onClick={() => setOpenSection(sectionTitle)}
            >
                <div
                    className="section-title"
                    dangerouslySetInnerHTML={{ __html: sectionTitle }}
                />
                <div className="section-list">
                    {section.map(item => (
                        <div
                            key={item.id}
                            className="section-list-item"
                        >
                            <HtmlStyledContent
                                className="section-list-item-content"
                                variant={Variants.ProductInfo}
                                html={item.description}
                            />
                        </div>
                    ))}
                </div>
                <div className="section-icon">
                    <div
                        className={classnames('section-icon-svg', {
                            'heart': iconUrl.includes('heart'),
                        })}
                        style={{ backgroundImage: `url(${iconUrl})` }}
                    />
                </div>
            </div>
        );
    };

    if (!sections) return null;

    return (
        <StyledComponent className="public-layout-section-product-info">
            <LayoutContainer>
                <div className="content-container">
                    <div
                        className="headline"
                        dangerouslySetInnerHTML={{ __html: headline }}
                    />
                    <div className="sections">
                        {renderSection(sections.benefits, subheadlines.benefits, '/images/product-info/heart.svg')}
                        {renderSection(sections.indications, subheadlines.indications, '/images/product-info/check-circle.svg')}
                        {renderSection(sections.contraindications, subheadlines.contraindications, '/images/product-info/xmark-circle.svg')}
                    </div>
                </div>
            </LayoutContainer>
        </StyledComponent>
    );
};

export default PublicLayoutSectionProductInfo;
